import React, { useRef, useContext } from "react";
import { useGSAP } from "@gsap/react";
import Context from "../OriginStoryProvider";
import { bgShapesParallax } from "../animations/animations";
import { SplitText } from "gsap/SplitText";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const QuoteWithCentredImg = () => {
	const {
		data: { content },
	} = useContext(Context);

	const quoteWithCentredImgContainer = useRef(null);
	const pinnedImg = useRef(null);
	const headlineQuoteText = useRef(null);

	useGSAP(
		() => {
			const split = new SplitText(headlineQuoteText.current, {
				type: "chars, words",
				wordsClass: "word",
			});

			const tl = gsap
				.timeline()
				.to(".chapter-2__quote-centred-img__quote", {
					"--lquo-opacity": 1,
				})
				.from(split.chars, {
					opacity: 0,
					rotate: (i) => -i * 0.1,
					y: (i) => -i * 0.1,
					skewY: -5,
					stagger: 0.2,
				})
				.from(".chapter-2__quote-centred-img__citation", {
					opacity: 0,
				});

			ScrollTrigger.create({
				trigger: quoteWithCentredImgContainer.current,
				start: "top top",
				pin: quoteWithCentredImgContainer.current,
				scrub: 2,
				animation: tl,
			});

			bgShapesParallax(pinnedImg.current, pinnedImg.current);
		},
		{
			scope: quoteWithCentredImgContainer.current,
			dependencies: [content.chapters],
		}
	);

	return (
		<div
			className="chapter-2__quote-centred-img"
			ref={quoteWithCentredImgContainer}
		>
			<img
				className="chapter-2__quote-centred-img__bg-img"
				srcSet={`${mainScript.assetPath}images/webp/chapter-2/quote-with-img-2-bg-400w.webp 400w, ${mainScript.assetPath}images/webp/chapter-2/quote-with-img-2-bg-600w.webp 600w, ${mainScript.assetPath}images/webp/chapter-2/quote-with-img-2-bg-800w.webp 800w, ${mainScript.assetPath}images/webp/chapter-2/quote-with-img-2-bg-1000w.webp 1000w, ${mainScript.assetPath}images/webp/chapter-2/quote-with-img-2-bg-1200w.webp 1200w, ${mainScript.assetPath}images/webp/chapter-2/quote-with-img-2-bg-1600w.webp 1600w, ${mainScript.assetPath}images/webp/chapter-2/quote-with-img-2-bg-2000w.webp 2000w`}
				sizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (min-width: 1601px) 2000px"
				src={`${mainScript.assetPath}images/jpg/chapter-2/quote-with-img-2-bg.jpg`}
				ref={pinnedImg}
				alt=""
				loading="lazy"

			/>
			<div className="main-grid">
				<div className="main-grid__margin"></div>
				<div className="main-grid__body">
					<div className="chapter-2__quote-centred-img__first-row">
						<p
							className="chapter-2__quote-centred-img__quote headline-quote"
							ref={headlineQuoteText}
						>
							{content.chapters.second.quote_with_img_2.quote}&rdquo;
						</p>
						<cite
							className="chapter-2__quote-centred-img__citation quote-attribute"
							dangerouslySetInnerHTML={{
								__html: content.chapters.second.quote_with_img_2.attribution,
							}}
						></cite>
					</div>
					<div className="chapter-2__quote-centred-img__second-row">
						<figure className="chapter-2__quote-centred-img__second-row__img-container">
							<img
								className="chapter-2__quote-centred-img__second-row__img"
								srcSet={`${mainScript.assetPath}images/webp/chapter-2/quote-with-img-2-img-400w.webp 400w, ${mainScript.assetPath}images/webp/chapter-2/quote-with-img-2-img-600w.webp 600w, ${mainScript.assetPath}images/webp/chapter-2/quote-with-img-2-img-800w.webp 800w, ${mainScript.assetPath}images/webp/chapter-2/quote-with-img-2-img-1000w.webp 1000w, ${mainScript.assetPath}images/webp/chapter-2/quote-with-img-2-img-1200w.webp 1200w`}
								sizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (min-width: 1001px) 1200px"
								src={`${mainScript.assetPath}images/png/chapter-2/quote-with-img-2-img.png`}
								alt={content.chapters.second.quote_with_img_2.img_alt}
								loading="lazy"
							/>
							<figcaption className="chapter-2__quote-centred-img__second-row__caption img-caption">
								{content.chapters.second.quote_with_img_2.img_caption}
							</figcaption>
						</figure>
					</div>
				</div>
				<div className="main-grid__margin"></div>
			</div>
		</div>
	);
};

export default QuoteWithCentredImg;
